import { inject, Injectable } from '@angular/core';
import { StorageKeys } from '@core/constants';
import { UserPreferences } from '@core/models/user-preferences';
import { StorageService } from '@core/services/storage/storage.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IUserProfileModel } from 'src/app/modules/user-profile/features/user-profile-page/models/user-profile.model';
import { UserProfileService } from 'src/app/modules/user-profile/features/user-profile-page/services/user-profile-page.service';
import {
  FinishGetUserProfile,
  GetUserProfile,
  InitGetUserProfile,
  LoadIsCollapsed,
  SetIsCollapsed,
} from './userProfile.actions';

@Injectable()
export class UserProfileEffects {
  private userProfileService: UserProfileService = inject(UserProfileService);
  private storageService: StorageService = inject(StorageService);
  private store: Store = inject(Store);
  private actions$: Actions = inject(Actions);

  getUserProfile$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(GetUserProfile),
        tap(() => {
          let userProfile: IUserProfileModel | null = null;
          this.store.dispatch(InitGetUserProfile());

          forkJoin({
            res: this.userProfileService.getCurrentUserProfileInfo(),
          }).subscribe(({ res }) => {
            userProfile = {
              ...res.data,
            } as any;

            this.storageService.save<any>(
              userProfile?.customer?.name,
              StorageKeys.userProfile
            );
            this.store.dispatch(
              FinishGetUserProfile({ profile: userProfile! })
            );
          });
        })
      );
    },
    { dispatch: false }
  );

  loadIsCollapsed$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(LoadIsCollapsed),
        tap((data) => {
          const { isCollapsed, isManualCollapsed } = data;

          const userPreferences = this.storageService.get<UserPreferences>(
            StorageKeys.userPreferences
          );

          const _isMenuCollapsed =
            typeof isCollapsed === 'boolean'
              ? isCollapsed
              : typeof userPreferences?.isMenuCollapsed === 'boolean'
                ? userPreferences?.isMenuCollapsed
                : false;

          const _isManualCollapsed =
            typeof isManualCollapsed === 'boolean'
              ? isManualCollapsed
              : typeof userPreferences?.isManualCollapsed === 'boolean'
                ? userPreferences?.isManualCollapsed
                : false;

          this.storageService.save<UserPreferences>(
            {
              ...userPreferences,
              isMenuCollapsed: _isMenuCollapsed,
              isManualCollapsed: _isManualCollapsed,
            },
            StorageKeys.userPreferences
          );

          this.store.dispatch(
            SetIsCollapsed({ isCollapsed: _isMenuCollapsed })
          );
        })
      );
    },
    { dispatch: false }
  );
}
